import { render, staticRenderFns } from "./OutstandingItemsModal.vue?vue&type=template&id=324f10ed&scoped=true&"
import script from "./OutstandingItemsModal.vue?vue&type=script&lang=js&"
export * from "./OutstandingItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./OutstandingItemsModal.vue?vue&type=style&index=0&id=324f10ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f10ed",
  null
  
)

component.options.__file = "OutstandingItemsModal.vue"
export default component.exports